import {GenericService, ResultType} from '@/shared/xhttp';
import {LongueursAchat} from '@/models';

export class LongueursAchatService extends GenericService<LongueursAchat> {
}